import { render, staticRenderFns } from "./phone-dialer.vue?vue&type=template&id=16c6c4c3&scoped=true&lang=pug&"
import script from "./phone-dialer.vue?vue&type=script&lang=js&"
export * from "./phone-dialer.vue?vue&type=script&lang=js&"
import style0 from "./phone-dialer.vue?vue&type=style&index=0&id=16c6c4c3&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c6c4c3",
  null
  
)

export default component.exports